export default {
  default: () => import("/buddy/roastar-combined/nuxt/layouts/default.vue").then(m => m.default || m),
  "design-lab": () => import("/buddy/roastar-combined/nuxt/layouts/design-lab.vue").then(m => m.default || m),
  fullscreen: () => import("/buddy/roastar-combined/nuxt/layouts/fullscreen.vue").then(m => m.default || m),
  "headless-ppc": () => import("/buddy/roastar-combined/nuxt/layouts/headless-ppc.vue").then(m => m.default || m),
  headless: () => import("/buddy/roastar-combined/nuxt/layouts/headless.vue").then(m => m.default || m),
  ppc: () => import("/buddy/roastar-combined/nuxt/layouts/ppc.vue").then(m => m.default || m)
}